export default "__VITE_ASSET__SeEmA7jF__"